<div class="container">
  <ng-content></ng-content>
  <img class="mt-[55px] mb-[60px] max-xs:mt-[40px]" src="{{deployURL}}assets/images/paymash-logo.svg" alt="" />
</div>
